import React, { useRef } from 'react';
import ReactMapboxGl, { Marker, ZoomControl } from 'react-mapbox-gl';
import PropTypes, { arrayOf } from 'prop-types';
import isEmpty from 'lodash.isempty';

import MapPinIcon from '@icons/MapPinIcon';
import 'mapbox-gl/dist/mapbox-gl.css';

const ReactMap = ReactMapboxGl({
    accessToken: process.env.MAPBOX_API_KEY_PUB,
    attributionControl: false,
});

/**
 * ReactMapBoxGl
 * @see https://github.com/alex3165/react-mapbox-gl/blob/master/docs/API.md
 */
const SearchMapboxMap = ({ markers, initialBounds, height, width, onCoordinatesChange }) => {
    const mapRef = useRef();

    if (isEmpty(initialBounds)) {
        return null;
    }

    return (
        <ReactMap
            ref={mapRef}
            /* eslint-disable-next-line */
            style="mapbox://styles/mapbox/streets-v11?optimize=true"
            containerStyle={{
                height,
                width,
            }}
            maxBounds={[
                [-180, -90], // Keeps the map from calculating bounds outside of Algolia's limits
                [180, 90],
            ]}
            fitBounds={initialBounds}
            fitBoundsOptions={{ padding: 50 }}
            onMoveEnd={(map, evt) => {
                if (evt?.fitboundUpdate) {
                    return;
                }
                onCoordinatesChange(map);
            }}
        >
            <>
                <ZoomControl />

                {markers.map((marker, markerIndex) => (
                    <Marker key={markerIndex} coordinates={[marker.lng, marker.lat]}>
                        <MapPinIcon />
                    </Marker>
                ))}
            </>
        </ReactMap>
    );
};

SearchMapboxMap.propTypes = {
    height: PropTypes.string,
    initialBounds: PropTypes.arrayOf(
        arrayOf(PropTypes.number, PropTypes.number),
        arrayOf(PropTypes.number, PropTypes.number)
    ),
    markers: PropTypes.arrayOf(
        PropTypes.shape({
            lat: PropTypes.number,
            lng: PropTypes.number,
        })
    ),
    onCoordinatesChange: PropTypes.func.isRequired,
    width: PropTypes.string,
};

export default SearchMapboxMap;
